import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Wearables = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M15 10.382h-1.667a.333.333 0 1 1 0-.667h1v-2h-1a.333.333 0 1 1 0-.666H15v3.333ZM12 4.049a.333.333 0 0 1-.32-.242l-.598-2.092H4.918l-.597 2.092a.334.334 0 1 1-.641-.183l.736-2.575h7.169l.735 2.575a.333.333 0 0 1-.32.425ZM11.585 16.381h-7.17l-.735-2.575a.334.334 0 1 1 .641-.183l.597 2.091h6.164l.598-2.091a.332.332 0 0 1 .653.052.333.333 0 0 1-.012.13l-.736 2.576Z" />
      <path d="M12 14.049H4a1.668 1.668 0 0 1-1.666-1.667V5.05a1.669 1.669 0 0 1 1.667-1.666h8a1.669 1.669 0 0 1 1.666 1.666v7.333A1.668 1.668 0 0 1 12 14.05Zm-8-10a1 1 0 0 0-1 1v7.333a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5.05a1 1 0 0 0-1-1H4Z" />
      <path d="M11.001 9.048H7.668v-3a.333.333 0 0 1 .667 0v2.333H11a.333.333 0 1 1 0 .667Z" />
    </svg>
  );
};

Wearables.category = 'product-category';

Wearables.displayName = 'Wearables';
